var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsIlDelivery = function SvgNnIconFlagsIlDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-IL-delivery_svg__Lager_45",
    "data-name": "Lager 45",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-IL-delivery_svg__cls-3{fill:#0048b3}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22v33.56H.13z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25 3.37h49.97v5.21H.25zM.25 25.23h49.97v5.2H.25zM29.39 16.91l2.09-3.61h-4.17l-2.08-3.6-2.08 3.6h-4.17l2.09 3.61-2.09 3.61h4.17l2.08 3.6 2.08-3.6h4.17Zm.1-2.46-.76 1.31-.76-1.31Zm-1.42 2.46-1.42 2.46h-2.84l-1.42-2.46 1.42-2.46h2.84Zm-2.84-4.92.76 1.31h-1.52Zm-4.26 2.46h1.52l-.76 1.31Zm0 4.92.76-1.31.76 1.31Zm4.26 2.46-.76-1.31h1.52Zm3.5-3.77.76 1.31h-1.52Z",
    className: "nn-icon-flags-IL-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsIlDelivery;